import { cn } from "@/lib/utils";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";

const flagMatcher = {
    ru: "/ru.png",
    en: "/en.png",
};

const ChangeLangMobile = () => {
    const locale = useLocale();
    const path = usePathname();
    const router = useRouter();
    const t_lang = useTranslations('Header');

    const changeLang = (l: string) => {
        if (locale !== l) {
            let splittedPath = path.split("/");
            const pathLang = splittedPath[0];
            splittedPath[1] = l;
            const correctPath = splittedPath.join("/");
            router.push(correctPath);
        }
    };

    return (
        <div className="flex justify-between items-center gap-2 transition-transform overflow-hidden rounded-sm mt-2 w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-none p-4">
            <p className="font-bold">{t_lang('language')}</p>
            <div className="flex items-center gap-1">
                <span onClick={() => changeLang('ru')} className={cn("w-[40px] h-[25px] cursor-pointer", locale === 'ru' && 'border-indigo-500 border-4 pointer-events-none select-none')}>
                    <Image className="w-full h-full object-cover" alt="" width={40} height={25} src={flagMatcher.ru} />
                </span>
                <span className="font-bold text-gray-500">|</span>
                <span onClick={() => changeLang('en')} className={cn("w-[40px] h-[25px] cursor-pointer", locale === 'en' && 'border-indigo-500 border-4 pointer-events-none select-none')}>
                    <Image className="w-full h-full object-cover" alt="" width={40} height={25} src={flagMatcher.en} />
                </span>
            </div>
        </div>
    );
};

export default ChangeLangMobile;